export const ALL = 1;
export const BUILDING_COMPLEX = 2;
export const BUILDING = 3;

export default Object.freeze({
  ALL,
  BUILDING_COMPLEX,
  BUILDING
});
